import Swiper from "swiper";
export default function () {
    new Swiper(".testimonials-slider", {
        slidesPerView: 1.3,
        spaceBetween: 80,
        loop: true,
        centeredSlides: true,
        navigation: {
            prevEl: '.testimonials-slider__nav-prev',
            nextEl: '.testimonials-slider__nav-next',
        },
    });
}
